var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",attrs:{"to":_vm.to,"href":_vm.to},on:{"click":_vm.notif}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }